import { useIntl } from "react-intl";

import { useSearchParameters } from "../../../hooks";
import { useConfirmationPage } from "../../../hooks/use-confirmation-page";
import {
    queryParam,
    useRegisterMetadata
} from "../../../hooks/use-registered-metadata";
import { getProductQueryParamTeamType } from "../../../models/user-segmentation";
import { getJtbdTemplateOverrideQueryParam } from "../../../utils/utils";
import {
    KANBAN_PROJECT_DEFAULTS,
    SCRUM_PROJECT_DEFAULTS,
    SampleProjectConfigurations,
    defaultSampleProjectConfiguration
} from "../utils/types";

export const useSampleProjectConfiguration = () => {
    const intl = useIntl();
    const {
        userSegmentationContext: { selectedTeamType = "" }
    } = useConfirmationPage();
    const { queryParamTeamType } = useSearchParameters();
    const metadata = useRegisterMetadata();

    const templateChoice =
        metadata?.get(queryParam.templateChoice) ??
        getJtbdTemplateOverrideQueryParam();

    const teamType = selectedTeamType ?? queryParamTeamType;
    const teamTypeShorthand = getProductQueryParamTeamType(teamType);

    const config =
        SampleProjectConfigurations[teamType] ??
        defaultSampleProjectConfiguration;

    const sampleProjectConfiguration = {
        ...config,
        columns: config.columns.map((column) => intl.formatMessage(column)),
        issueTypes: config.issueTypes.map((issueType) => ({
            ...issueType,
            name: intl.formatMessage(issueType.name)
        }))
    };

    const details =
        templateChoice === "kanban"
            ? KANBAN_PROJECT_DEFAULTS
            : SCRUM_PROJECT_DEFAULTS;

    const projectDetails = {
        ...details,
        defaultProjectName: intl.formatMessage(details.defaultProjectName)
    };

    return {
        teamType: teamTypeShorthand,
        sampleProjectConfiguration,
        projectDetails
    };
};
